import "./style.css";
const FavoriteItem = ({ item, removeFromFavorites }) => {
  const { title, image, id } = item;
  return (
    <div className="recipe-item">
      <div>
        <img src={image} alt={title} />
      </div>
      <h3>{title}</h3>
      <button className="btn" type="button" onClick={removeFromFavorites}>
        Remove from favorite
      </button>
    </div>
  );
};

export default FavoriteItem;
